import { buildPtusFrontendUrl } from '@ptml/root-config';

/**
 * Base URLs for different sections of the application.
 */
export const BASE_URLS = {
    jobs: '/jobs',
    returns: '/returns',
    credits: '/credits',
};

/**
 * URLs for various pages in the application.
 */
export const PAGES = {
    jobs: 'jobs',
    jobdetail: 'jobdetail',
    jobDetailInstantOrder: 'jobdetail',
    reports: buildPtusFrontendUrl('Reporting/ReportBusinessPerformanceList'),
    feedback: buildPtusFrontendUrl('CompanyFeedback/FeedbackAssigned'),
    settings: buildPtusFrontendUrl('Profile/MyCompany/RepairerSettings'),
    companySummary: buildPtusFrontendUrl('Profile/MyCompany/Summary'),
    companyProfile: buildPtusFrontendUrl('Profile/MyCompany/CompanyProfile'),
    viewCompanyUsers: buildPtusFrontendUrl(
        'Profile/MyCompany/ManageCompanyUsers',
    ),
    addUser: buildPtusFrontendUrl('Profile/MyCompany/AddUser'),
    resetUserPassword: buildPtusFrontendUrl(
        'Profile/MyCompany/ResetUserPassword',
    ),
    repairerCompanySettings: buildPtusFrontendUrl(
        'Profile/MyCompany/RepairerSettings',
    ),
    supplierCompanySettings: buildPtusFrontendUrl(
        'Profile/MyCompany/SupplierSettings',
    ),
    dataSharing: buildPtusFrontendUrl('Profile/MyCompany/DataSharing'),
    invoiceAndPayments: buildPtusFrontendUrl('InvoiceAndPayments'),
    preferredSuppliers: buildPtusFrontendUrl(
        'Profile/MyCompany/PreferredSuppliers',
    ),
    preferredOemSuppliers: buildPtusFrontendUrl(
        'Profile/MyCompany/PreferredOemSuppliers/List',
    ),
    actOnBehalfAuthorizations: buildPtusFrontendUrl(
        'Profile/MyCompany/ActOnBehalf',
    ),
    registeredPiClients: buildPtusFrontendUrl('Profile/MyCompany/PIClients'),
    companyRatingComments: buildPtusFrontendUrl(
        'Profile/MyCompany/CompanyRatings/ViewRatingComments',
    ),
    companyRatingDetails: buildPtusFrontendUrl(
        'Profile/MyCompany/CompanyRatings/ViewRatingDetails',
    ),
    locationAuthorization: buildPtusFrontendUrl(
        'Profile/MyCompany/LocationAuthorization',
    ),
    manageSubCompanies: buildPtusFrontendUrl(
        'Profile/MyCompany/ManageSubCompanies',
    ),
    activity: buildPtusFrontendUrl('AllActivity'),
    returns: 'returns',
    invoices: 'invoices',
    invoice: 'invoices/invoice',
    invoiceScan: 'invoices/scan',
    invoiceDuplicateReview: 'invoices/duplicate-review',
    settingsPreferredVendors: 'settings/preferred-vendors',
    settingsPreferredVendorsVendor: 'settings/preferred-vendors/vendor',
    settingsMultiLocationAccess: 'settings/multi-location-access',
    activeJobs: 'jobs/active-jobs',
    jobCompliance: 'job-compliance',
    credits: 'credits',
};

/**
 * Paths for various routes in the application.
 */
export const PATHS = {
    /**
     * job MFE: Jobs dashboard
     */
    jobs: `${BASE_URLS.jobs}/active-jobs`,
    /**
     * jobdetail MFE: List of parts page
     */
    jobdetail: `/job/:id`,
    jobdetailActionRequired: `/job/:id?status=actionRequired`,
    /**
     * invoices MFE: Invoices dashboard
     */
    invoices: '/invoices',
    /**
     * invoices MFE: Invoice page
     */
    invoice: '/invoices/invoice/:invoiceId',
    /**
     * invoices MFE: Edit invoice page
     */
    invoiceEdit: '/invoices/invoice/:invoiceId/edit',
    /**
     * invoices MFE: Edit invoice line item page
     */
    invoiceLineItemEdit:
        '/invoices/invoice/:invoiceId/lineitem/:lineItemId/edit',
    /**
     * invoices MFE: Extract data page
     */
    invoiceExtract: '/invoices/invoice/:invoiceId/extract',
    /**
     * invoices MFE: Match to PO page
     */
    invoiceMatch: '/invoices/invoice/:invoiceId/match',
    /**
     * invoices MFE: Scanner page
     */
    invoiceScan: '/invoices/scan',
    /**
     * invoices MFE: Duplicate invoice review page
     */
    invoiceDuplicateReview: '/invoices/duplicate-review/:invoiceScanId',
    /**
     * invoices MFE: Duplicate invoice review page from invoice edit
     */
    invoiceEditDuplicateReview:
        '/invoices/invoice/:invoiceId/duplicate-review/:duplicateOfInvoiceId',
    /**
     * returns MFE: Returns dashboard
     */
    returns: '/returns',
    /**
     * returns MFE: Returns detail page
     */
    returnsDetail: '/returns/:returnId',
    /**
     * returns MFE: Create a new return page
     */

    returnsNewWithPart: '/returns/new/:orderId/:orderPartId',
    /**
     * credits MFE: Credits dashboard
     */
    credits: '/credits',
    /**
     * credits MFE: Credits detail page
     */
    creditsDetail: '/credits/:creditMemoId',
    /**
     * returns MFE: Create a new return page
     */
    coreReturnsNewWithPart: '/returns/new/core/:orderId/:orderPartId',

    jobDetailInstantOrder: `/job/:id/instantorder`,
    /*
     * settings MFE: Settings preferred vendor
     */
    settingsPreferredVendors: '/settings/preferred-vendors',
    /**
     * settings MFE: vendor page
     */
    settingsPreferredVendorsVendor:
        '/settings/preferred-vendors/vendor/:vendorId',
    /**
     * settings MFE: multi location access dashboard
     */
    settingsMultiLocationAccess: '/settings/multi-location-access',
    /**
     * jobCompliance MFE: Job compliance page
     */
    jobCompliance: '/job-compliance/:id',
};
